<div class="controls-panel">
  <div class="title">
    <h3>Profit <i [style]="{opacity: loading ? 1 : 0}" class="fas fa-sync fa-spin text-muted title-spinner"></i></h3>
  </div>
  <div class="controls">

  </div>
</div>
<div #chartContainer>
  <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions" (chartInstance)="setChart($event)"></highcharts-chart>
</div>
<ng-template #profitDetailStatisticPeriodModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Profit details</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body ">
    <div [hidden]="!profitDetailStatisticPeriodLoading" class="spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
    <div class="table-topbar mb-20">
      <div class="panel">
        <span class="icon-search"></span>
        <input type="search" class="form-control search-control" [formControl]="searchControl" />
      </div>
      <div class="panel panel-right">
        <div class="date-filter-drop">
          <input-search-period [start]="start" [end]="end" [customClass]="'primary'" [autoApply]="false" (change)="onChangeDateProfitDetailStatistic($event)"
            [placeholder]="'All time'"></input-search-period>
        </div>
        <button [disabled]="!profitDetailStatisticPeriodRows.length" (click)="onClickButtonExportProfitDetail()" class="btn btn-export btn-outline-dark"><i
            class="icon-export"></i></button>
      </div>
    </div>
    <div class="table-container">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Email</th>
            <th>Owner</th>
            <th>MT Price per test</th>
            <th
              [ngClass]="{'sorting_asc': profitDetailStatisticPeriodSort === 'mtTestCount', 'sorting_desc': profitDetailStatisticPeriodSort === '-mtTestCount'}"
              class="sorting cp" (click)="setProfitDetailStatisticPeriodSort('mtTestCount')">
              MT Count
            </th>
            <th>MO Price per test</th>
            <th
              [ngClass]="{'sorting_asc': profitDetailStatisticPeriodSort === 'moTestCount', 'sorting_desc': profitDetailStatisticPeriodSort === '-moTestCount'}"
              class="sorting cp" (click)="setProfitDetailStatisticPeriodSort('moTestCount')">
              MO Count
            </th>
            <th>CLI Price per test</th>
            <th
              [ngClass]="{'sorting_asc': profitDetailStatisticPeriodSort === 'cliTestCount', 'sorting_desc': profitDetailStatisticPeriodSort === '-cliTestCount'}"
              class="sorting cp" (click)="setProfitDetailStatisticPeriodSort('cliTestCount')">
              CLI Count
            </th>
            <th [ngClass]="{'sorting_asc': profitDetailStatisticPeriodSort === 'profit', 'sorting_desc': profitDetailStatisticPeriodSort === '-profit'}"
              class="sorting cp" (click)="setProfitDetailStatisticPeriodSort('profit')">
              Profit
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let row of profitDetailStatisticPeriodRows | sort: profitDetailStatisticPeriodSort | filterText:profitDetailStatisticPeriodSearch:['userEmail']"
            class="row-table">
            <td>{{ row.userEmail }}</td>
            <td>{{ row.ownerEmail }}</td>
            <td [ngClass]="{empty: row.mtPricePerTest === 0}">{{ row.mtPricePerTest === 0 ? 'N/A' : ('€'+row.mtPricePerTest) }}</td>
            <td [ngClass]="{empty: row.mtTestCount === 0}">{{ row.mtTestCount === 0 ? 'N/A' : row.mtTestCount }}</td>
            <td [ngClass]="{empty: row.moPricePerTest === 0}">{{ row.moPricePerTest === 0 ? 'N/A' : ('€'+row.moPricePerTest) }}</td>
            <td [ngClass]="{empty: row.moTestCount === 0}">{{ row.moTestCount === 0 ? 'N/A' : row.moTestCount }}</td>
            <td [ngClass]="{empty: row.cliPricePerTest === 0}">{{ row.cliPricePerTest === 0 ? 'N/A' : ('€'+row.cliPricePerTest) }}</td>
            <td [ngClass]="{empty: row.cliTestCount === 0}">{{ row.cliTestCount === 0 ? 'N/A' : row.cliTestCount }}</td>
            <td>&euro;{{ row.profit }}</td>
          </tr>
          <tr *ngIf="profitDetailStatisticPeriodRows.length === 0" class="row-table">
            <td class="text-center" [colSpan]="7">Empty</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer pt-15">
    <h4 style="text-align: right"><span class="text-primary">SUM: </span>&euro;{{ profitDetailStatisticPeriodSum }}</h4>
  </div>
</ng-template>
